(function(){
  async function request(url,viewclass){
  const xhttp = new XMLHttpRequest();
    await data(xhttp,url,viewclass);
}
function data(xhttp,url,viewclass){
  xhttp.onreadystatechange = function () {
    if (this.readyState == 4 && this.status == 200) {
      const responseStr = this.responseText;
      printData(responseStr,viewclass);
    }
  };
  xhttp.open("GET", url, true);
  xhttp.send();
}
  function printData(data,viewclass){
    viewitem = document.getElementsByClassName(viewclass);
    viewitem[0].insertAdjacentHTML('beforeend', data);
  }
  let classname= document.querySelectorAll('.js-json-wrapper');
  let viewname= document.querySelectorAll('[data-attr="viewname"]');

  let pageurl;

  for(let i=0;i<viewname.length;i++){
    var viewclass= viewname[i].innerHTML.split('/').join('_');
    pageurl = viewname[i].innerHTML;
    viewclass= 'js'+viewclass;
    const pathParts = pageurl.replace(/^\//, '').split('/').filter(Boolean);
    // 3-segment paths match /api/v1/html/{a}/{b}/{c} and render current Twig.
    // Static S3 files (public://api/v1/html) are only refreshed by cron queues.
    let url = pathParts.length === 3
      ? '/api/v1/html' + pageurl
      : '/sites/default/files/api/v1/html' + pageurl + '.html';
  if(classname){request(url,viewclass)}
  }
})();
